import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  ContainerCalendar, BackgroundColorRounded, BoxContainer, SelectColors,
  Pre, PreContainer, CopyButton
} from "./styles";

import { FiCopy } from 'react-icons/fi';
import { BsCheckLg } from 'react-icons/bs';

import Tooltip from '@mui/material/Tooltip';

import timeGridPlugin from "@fullcalendar/timegrid";
import { Button, Modal, TextField } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ICalParser from 'ical-js-parser';
import Switch from '@mui/material/Switch';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Select from 'react-select';
import { uuidv4 } from "../utils";
import moment from 'moment-timezone';
import html2canvas from 'html2canvas';

import ReactDOM from 'react-dom';


import React, { useEffect, useState, useRef } from "react";
import './CalendarScheduler.css';

// constants

const ListColorsCard = [
  { backgroundColor: '#d50000', textColor: '#ffffff' },
  { backgroundColor: '#33b679', textColor: '#ffffff' },
  { backgroundColor: '#f6bf26', textColor: '#ffffff' },
  { backgroundColor: '#039be5', textColor: '#ffffff' },
  { backgroundColor: '#616161', textColor: '#ffffff' },
];

export const CalendarScheduler = (eventsCalendar) => {
  // get events from localstorage
  const localStorageEvents = JSON.parse(window.localStorage.getItem("SCHEDULESHARE_EVENTS")) || [];
  const [activeEvent, setActiveEvent] = useState();
  const [activeEventMode, setActiveEventMode] = useState("");
  const [events, setEvents] = useState(localStorageEvents);
  const [isEditCard, setIsEditCard] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState(moment.tz.guess());
  const [simpleMode, setSimpleMode] = useState(false);
  const [showModalReset, setShowModalReset] = useState(false);
  const calendarRef = useRef(null);
  const preRef = useRef(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const [copyValue, setCopyValue] = useState("");

  // useEffect on activeEvent
  useEffect(() => {
    // if simpleMode is true, directly add it to events without popups
    if (simpleMode && activeEvent && Object.keys(activeEvent).length != 0 && activeEventMode === "ADD") {
      handleAddedEvent();
      setActiveEventMode("");
    }
  }, [activeEvent])

  const weekends = {
    weekendsVisible: true,
    currentEvents: [],
  };

  // const modalInfosEvent = useDisclosure(false);

  const handleAddEventSelectAndOpenModal = (selectInfo) => {
    setIsEditCard(false);
    /* 
      // add event to setEvents
      const eventsNew = [...events, {
        title: 'dummy title',
        start: selectInfo.startStr,
        end: selectInfo.endStr,
      }]
      setEvents(eventsNew);
    */

    // convert activeEvent times to GMT before saving
    // start, end strings must be converted to selectedTimeZone
    setActiveEvent({
      id: uuidv4(),
      title: '',
      start: moment.tz(moment(selectInfo.startStr).format("YYYY-MM-DDTHH:mm:ss"), selectedTimezone).format(),
      end: moment.tz(moment(selectInfo.endStr).format("YYYY-MM-DDTHH:mm:ss"), selectedTimezone).format(),
      textColor: selectInfo.color,
      backgroundColor: selectInfo.backgroundColor,
    })
    setActiveEventMode("ADD");
    // if simpleMode is true, call handleAddedEvent instantly
    if (!simpleMode) {
      setIsModalOpen(true);
    }
  };

  const handleEditEventSelectAndOpenModal = (clickInfo) => {
    setIsEditCard(true);

    setActiveEvent({
      id: clickInfo.event.id,
      title: clickInfo.event.title,
      // It's okay to not change start, end times because only title and color options matter here
      start: clickInfo.event.startStr,
      end: clickInfo.event.endStr,
      textColor: clickInfo.event.color,
      backgroundColor: clickInfo.event.backgroundColor,
    })
    setIsModalOpen(true);
  };

  const handleUpdateEventSelect = async (changeInfo) => {
    // search and update state.events
    const eventsNew = [...events]
    for (let i = 0; i < eventsNew.length; i++) {
      if (eventsNew[i].id === changeInfo.event.id) {
        eventsNew[i] = {
          ...eventsNew[i],
          start: moment.tz(moment(changeInfo.event.startStr).format("YYYY-MM-DDTHH:mm:ss"), selectedTimezone).format(),
          end: moment.tz(moment(changeInfo.event.endStr).format("YYYY-MM-DDTHH:mm:ss"), selectedTimezone).format(),
        };
        break;
      }
    }
    setEvents(eventsNew);
    saveToLocalStorage(eventsNew);
    handleClose();
  };

  const saveToLocalStorage = (eventsNew) => {
    // change times
    for (let i = 0; i < eventsNew.length; i++) {
      const event = eventsNew[i];
      event.start = moment(event.start).utc().format();
      event.end = moment(event.end).utc().format();

    }
    // save events to localstorage
    window.localStorage.setItem("SCHEDULESHARE_EVENTS", JSON.stringify(eventsNew));
  }

  // TODO: handleClose, setTitle, handleSelectCardColor, handleUpdatedEvent, handleAddedEvent, handleDeleteEvent

  const handleClose = () => {
    if (activeEvent) {
      setIsModalOpen(false);
      // reset activeEvent
      setActiveEvent({})
    }
    setIsModalOpen(false);
  }

  const handleUpdatedEvent = () => {
    // search and update state.events
    const eventsNew = [...events]
    for (let i = 0; i < eventsNew.length; i++) {
      if (eventsNew[i].id === activeEvent.id) {
        eventsNew[i] = { ...eventsNew[i], textColor: activeEvent.textColor, backgroundColor: activeEvent.backgroundColor, title: activeEvent.title };
        break;
      }
    }
    setEvents(eventsNew);
    saveToLocalStorage(eventsNew);
    handleClose();
  }

  const handleAddedEvent = () => {

    // write to events
    const eventsNew = [...events, activeEvent];
    setEvents(eventsNew);
    // save events to localstorage
    saveToLocalStorage(eventsNew);
    handleClose();
  }

  const getTimezones = () => {
    const offsets = [];
    moment.tz.names().forEach((zoneName) => {
      const offset = moment.tz(zoneName).utcOffset() / 60;
      const sign = offset >= 0 ? "+" : "-";
      const hours = Math.abs(offset);
      const offsetLabel = `GMT${sign}${hours.toString().padStart(2, "0")}`;
      const label = `${zoneName} (${offsetLabel})`;
      offsets.push({ value: zoneName, label });
    });
    return offsets;
  }

  const getEventsWithTimeZone = () => {
    const event = events[0];
    // events are reset to their respective timezone
    const eventsUpdated = events.map((event) => ({
      ...event,
      start: moment.tz(event.start, selectedTimezone).format('YYYY-MM-DDTHH:mm:ss'),
      end: moment.tz(event.end, selectedTimezone).format('YYYY-MM-DDTHH:mm:ss'),
    }));
    return eventsUpdated;
  }

  const resetCalendar = () => {
    // backup existing events
    window.localStorage.setItem("SCHEDULESHARE_EVENTS_BACKUP", JSON.stringify(events));
    // set events = []
    setEvents([]);
    // reset localStorage
    window.localStorage.setItem("SCHEDULESHARE_EVENTS", null);
  }

  const generateTextSummary = () => {
    // sort events by start time
    events.sort((a, b) => {
      var keyA = new Date(a.start),
        keyB = new Date(b.start);
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });
    // group events by day
    const eventsGroupedByDay = {}
    for (let i = 0; i < events.length; i++) {
      // change start and end dates to timezone
      const event = {...events[i]};
      event.start = moment.tz(event.start, selectedTimezone).format("YYYY-MM-DDTHH:mm:ss");
      event.end = moment.tz(event.end, selectedTimezone).format("YYYY-MM-DDTHH:mm:ss");
      const eventDate = moment(event.start).format('YYYY-MM-DD');
      if (eventsGroupedByDay[eventDate]) {
        eventsGroupedByDay[eventDate].push(event);
      } else {
        eventsGroupedByDay[eventDate] = [event];
      }
    }
    const eventsGroupedByDaySorted = Object.keys(eventsGroupedByDay).sort().reduce(
      (obj, key) => {
        obj[key] = eventsGroupedByDay[key];
        return obj;
      },
      {}
    );
    let textSummaryString = ""
    for (let k in eventsGroupedByDaySorted) {
      const eventsInDate = eventsGroupedByDaySorted[k];
      if (eventsInDate && eventsInDate.length > 0) {
        textSummaryString += k + "\n"
      }
      for (let i = 0; i < eventsInDate.length; i++) {
        const event = eventsInDate[i];
        const startFormatted = moment(event.start).format("HH:mm");
        const endFormatted = moment(event.end).format("HH:mm");
        // time string
        textSummaryString += `\t${startFormatted} - ${endFormatted}`;
        // title string
        textSummaryString += event.title ? " - " + event.title : "";
        textSummaryString += "\n"
      }
    }
    document.getElementById("summary-text").innerHTML = textSummaryString;
    setCopyValue(textSummaryString);
  }

  // const generateAvailability = () => {
  //   // start at any event
  // }

  const handleCopyClick = () => {
    if (preRef.current) {
      navigator.clipboard.writeText(preRef.current.textContent);
      setCopySuccess(true);
      setTimeout(() => {
        setCopySuccess(false);
      }, 2000);
    }
  };

  const handleICalUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      if (evt.target.readyState != 2) return;
      if (evt.target.error) {
        return;
      }
      const fileContent = evt.target.result;
      const resultJSON = ICalParser.toJSON(fileContent);
      const eventsICS = resultJSON.events;

      let newEvents = [];
      // iterate through events and add to newEvents
      for (let i = 0; i < eventsICS.length; i++) {
        const event = eventsICS[i];
        newEvents.push({
          id: uuidv4(),
          title: event.summary,
          start: event.dtstart.timezone ? moment.tz(event.dtstart.value, event.dtstart.timezone).format() : moment(event.dtstart.value).format(),
          end: event.dtend.timezone ? moment.tz(event.dtend.value, event.dtend.timezone).format() : moment(event.dtend.value).format(),
          textColor: "#ffffff",
          backgroundColor: "#039be5",
        })
      }
      newEvents = [...events, ...newEvents]
      setEvents(newEvents);
      saveToLocalStorage(newEvents);
    };
    reader.readAsText(file);
  }
  const handleScreenshot = () => {
    const element = ReactDOM.findDOMNode(calendarRef.current);
    html2canvas(element).then((canvas) => {
      const dataURL = canvas.toDataURL('image/png');
      const downloadLink = document.createElement('a');
      downloadLink.href = dataURL;
      downloadLink.download = 'calendar.png';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };

  const handleDeleteEvent = () => {
    // search and update state.events
    let eventsNew = [...events]
    // remove event from eventsNew
    eventsNew = eventsNew.filter((event) => { return event.id != activeEvent.id });
    setEvents(eventsNew);
    saveToLocalStorage(eventsNew);
    handleClose();
  }
  const selectStyles = {
    menu: base => ({
      ...base,
      zIndex: 100
    })
  };

  const handleResetEvents = () => {
    setShowModalReset(true);
  };

  const handleConfirmResetEvents = () => {
    // reset
    resetCalendar();
    setShowModalReset(false);
  };

  const handleCancelResetEvents = () => {
    setShowModalReset(false);
  };

  return (
    <div className="content">
      {/* Toolbox */}
      <div className="input-box">
        <h3 id="label-input-box">Configuration</h3>
        <Grid container className="toolbox">
          <Grid item xs={12} sm={6} md={6} className="timezone-select-container">
            <p>Switch to a different timezone</p>
            <Select
              disablePortal
              id="select-timezone"
              options={getTimezones()}
              defaultValue={getTimezones().filter(option => option.value === selectedTimezone)}
              onChange={(e) => { setSelectedTimezone(e.value) }}
              styles={selectStyles}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} className="simple-mode-checkbox">
            <p>
              Enable simple mode &nbsp;
              <Tooltip title="Activating simple mode doesn't prompt to edit title and event colors after selecting event duration.">
                <span id="simple-mode-info">?</span>
              </Tooltip>
            </p>
            <Switch
              checked={simpleMode}
              onChange={(event) => {
                setSimpleMode(event.target.checked);
              }}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} className="ical-upload-container">
                <label className="button-4" variant="contained" component="label">
                  Upload ICS/iCal
                  <input hidden onChange={(e) => handleICalUpload(e.target.files[0])} type="file" />
                </label>
              </Grid>
              <Grid item xs={12} className="reset-container">
                <button className="button-4 danger" onClick={handleResetEvents}>Reset Calendar</button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>


      <ContainerCalendar>
        <Modal open={isModalOpen} onClose={handleClose}>
          <BoxContainer>
            <TextField label={'Title'} defaultValue={activeEvent?.title} onChange={(e) => {
              activeEvent.title = e.target.value;
              setActiveEvent(activeEvent)
            }} fullWidth />

            <SelectColors>
              {ListColorsCard.map((color, index) => (
                <BackgroundColorRounded
                  key={index}
                  selected={false}
                  color={color.backgroundColor}
                  onClick={() => {
                    activeEvent.textColor = color.textColor;
                    activeEvent.backgroundColor = color.backgroundColor;
                    setActiveEvent(activeEvent);
                  }}
                >
                  <input
                    type="radio"
                    name="cardColor"
                    defaultChecked={color.backgroundColor === activeEvent?.backgroundColor}
                  />
                </BackgroundColorRounded>
              ))}
            </SelectColors>

            <Button
              variant="contained"
              fullWidth
              onClick={isEditCard ? handleUpdatedEvent : handleAddedEvent}
              sx={{ marginTop: '0.5rem' }}
            >
              {isEditCard ? 'Edit Event' : 'Add Event'}
            </Button>

            {isEditCard && (
              <Button variant="contained" fullWidth sx={{ marginTop: '0.5rem' }} onClick={handleDeleteEvent}>
                Delete Event
              </Button>
            )}
          </BoxContainer>
        </Modal>

        <Modal open={showModalReset} onClose={handleCancelResetEvents}>
          <BoxContainer>
            <p className="modal-text">Are you sure you want to delete all events in the calendar?</p>
            <Grid container>
              <Grid item xs={12} sm={3} smOffset={3} className="button-container">
                <button className="button-4 danger" onClick={handleConfirmResetEvents}>Yes</button>
              </Grid>
              <Grid item xs={12} sm={3} className="button-container">
                <button className="button-4" onClick={handleCancelResetEvents}>No</button>
              </Grid>
            </Grid>

          </BoxContainer>
        </Modal>

        <FullCalendar
          ref={calendarRef}
          plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
          initialView="timeGridWeek"
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          weekends={weekends.weekendsVisible}
          select={handleAddEventSelectAndOpenModal}
          eventClick={handleEditEventSelectAndOpenModal}
          eventChange={handleUpdateEventSelect}
          // initialEvents={events}
          events={getEventsWithTimeZone()}
          longPressDelay={1000}
          eventLongPressDelay={1000}
          selectLongPressDelay={1000}
          selectable={true}
          dayMaxEvents={true}
          allDaySlot={false}
          editable={true}
          height="700px"
          eventTimeFormat={{ hour: 'numeric', minute: '2-digit' }}
        />
      </ContainerCalendar>

      <div className="output-gen">
        <h3 id="label-output-box">Output Options</h3>
        <div id="output-content">
          <Grid container>
            <Grid item xs={12} sm={6} lg={4} className="output-buttons">
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <div className="text-summary-container">
                    <div>
                      <button className="button-4" variant="contained" onClick={generateTextSummary}>Generate text summary</button>
                    </div>
                  </div>
                </Grid>
                {/* <Grid item xs={12}>
                  <div className="availability-summary-container">
                    <div>
                      <button className="button-4" variant="contained" onClick={generateAvailability}>Generate availability</button>
                    </div>
                  </div>
                </Grid> */}
                <Grid item sm={12}>
                  <div className="image-generator-container">
                    <button variant="contained" className="button-4" onClick={handleScreenshot}>Download screenshot of calendar</button>
                  </div>
                </Grid>
              </Grid>

            </Grid>
            <Grid item xs={12} sm={6} lg={8} className="summary-container">
              <div placeholder="Schedule summary" id="summary">
                {/* <span id="copy-summary"></span> */}
                <PreContainer>
                  <h3>Summary of Events</h3>
                  <Pre id={"summary-text"} ref={preRef}></Pre>
                  <CopyToClipboard text={copyValue}
                    onCopy={() => {
                      setCopySuccess(true);
                      setTimeout(() => {
                        setCopySuccess(false);
                      }, 2000);
                    }}>
                    <CopyButton>
                      {copySuccess ? <BsCheckLg style={{ "color": "#188028" }} size={20} /> : <FiCopy size={20} />}
                    </CopyButton>

                  </CopyToClipboard>
                </PreContainer>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <div id="footer">
        <Grid container className="footer-grid-c">
          <Grid item sm={1}>
            <a href="https://gist.github.com/plant99/e66026207ea133c32a841bb3cdaf4b7d">User Guide</a>
          </Grid>
          <Grid item sm={1}>
            <a href="https://github.com/plant99/closed-source-issues/issues/new">Report an issue</a>
          </Grid>
          {/* <Grid item sm={1.5}>
            <a href="#">Rate Schedule-Share</a>
          </Grid> */}
        </Grid>
      </div>
    </div>
  );
};